import { writeClientLastSeenUpdateId } from "#/lib/updatesSeen";
import { markUpdatesSeen } from "#/server/markUpdatesSeen";

export async function persistUpdatesSeen({
  updateId,
  isSignedIn,
}: {
  updateId: string;
  isSignedIn: boolean;
}): Promise<void> {
  writeClientLastSeenUpdateId(updateId);
  if (isSignedIn) {
    await markUpdatesSeen({ data: { updateId } }).catch(() => {});
  }
}
